export default __webpack_public_path__ + "static/media/users-icon.0302b42d.svg";